module.exports = __webpack_public_path__ + "static/step-3-img-e6302a0feee4f754f55748931ed85ae3.png";